exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label {\n  color: rgba(0, 0, 0, 0.42); }\n\n.notes {\n  color: black;\n  max-height: 200px;\n  overflow-y: auto;\n  margin-top: 5px;\n  margin-bottom: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/communication/event-detail/event-detail.component.scss
// module id = ../../../../../src/app/communication/event-detail/event-detail.component.scss
// module chunks = main